import React, { useEffect } from "react";

import { Loading } from "@components";

export interface RedirectProps {
    to: URL;
}

export const Redirect = (props: RedirectProps) => {
    const { to } = props;

    useEffect(() => {
        window.location.href = to.toString();
    }, [to]);

    return <Loading />;
};
